import { Component, ChangeDetectionStrategy, ElementRef, ViewChild, HostListener, Input } from '@angular/core';
import { AspectRatio } from '@knorr-bremse-portals/ngx-components';
import { PictureComponent, PictureSources, PictureVariants } from '@knorr-bremse-portals/ngx-components/components/picture';

@Component({
  selector: 'kb-picture-lightbox',
  templateUrl: './picture-lightbox.component.html',
  styleUrls: ['./picture-lightbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ PictureComponent ],
})
export class PictureLightboxComponent {

  @Input({ required: true }) public picture!: PictureSources;
  @Input({ required: true }) public alt!: string;

  @ViewChild('dialog') private dialogElement?: ElementRef<HTMLDialogElement>;

  protected originalVariants: PictureVariants = [{aspectRatio: AspectRatio.Original}];

  @HostListener('click')
  public openZoom(): void {
    this.dialogElement?.nativeElement.showModal();
  }

  public closeZoom(): void {
    this.dialogElement?.nativeElement.close();
  }

}
